/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyYearModule
 * Purpose		: Module for SummaryofSalesbyYear.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { SummaryofSalesbyYearService } from './SummaryofSalesbyYear.service';
import { SummaryofSalesbyYearListComponent } from './SummaryofSalesbyYearList.component';
import { SummaryofSalesbyYearSearchComponent } from './SummaryofSalesbyYearSearch.component';
import { SummaryofSalesbyYearDetailsComponent } from './SummaryofSalesbyYearDetails.component';

import { SummaryofSalesbyYearRoutingModule } from './SummaryofSalesbyYear-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    SummaryofSalesbyYearRoutingModule
  ],
  declarations: [
    SummaryofSalesbyYearListComponent,
	SummaryofSalesbyYearSearchComponent,
	SummaryofSalesbyYearDetailsComponent
  ],
  providers: [
    SummaryofSalesbyYearService
  ]
})

export class SummaryofSalesbyYearModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/SummaryofSalesbyYear/SummaryofSalesbyYear.module.ts